// Resolución de "qué precio de lista le toca a este cliente para este insumo".
//
// Hoy este algoritmo está copiado a mano en 6 pantallas de captura (AgregarVenta,
// los dos PuntoDeVenta, las dos VentasProgramadas y VentaConsignacion). Aquí queda
// escrito una sola vez para que las que se escriban de ahora en adelante tengan a
// dónde converger; las 6 existentes se dejaron como estaban a propósito.
//
// Referencia: AgregarVenta.js:2849-2851 (elegir la lista) y :2193-2196 (precio del insumo).

// El cliente guarda dos listas: la de contado y la de crédito. Si le falta la que
// corresponde al método de pago, se cae a la otra antes de rendirse: media captura
// con precios es mejor que ninguna.
export const precioIdDeCliente = (cliente, contado) =>
  (contado === 1 ? cliente?.precioContadoId : cliente?.precioCreditoId) ||
  cliente?.precioContadoId ||
  cliente?.precioCreditoId ||
  null;

// El precio vive por lista dentro del insumo (Insumo.precios[]), no por cliente.
// Devuelve undefined —no 0— si el insumo no tiene capturado un precio en esa lista:
// en InsumoCliente el precio es opcional, y un 0 se guardaría como un precio de
// contrato real de cero.
export const precioDeLista = (insumo, precioId) => {
  if (!precioId || !Array.isArray(insumo?.precios)) return undefined;
  const entrada = insumo.precios.find(
    (valuePrecio) => valuePrecio.precioId?.toString() === String(precioId)
  );
  return entrada ? entrada.precio : undefined;
};
